<template>
    <div style="height: 300px;" class="d-flex justify-content-center align-items-center">
        <div v-if="data.length > 0" ref="piechart" style="width:100%;" :style="`height: ${height}`"></div>
        <div v-else style="text-align: center;">No Data Available</div>
    </div>
</template>

<script>
export default {
  name: 'ManualGoogleChart',
  props: {
    data: {
      type: Array,
      default: () => [
      ],
    },
    keys: {
        type: Array,
        default: () => [
        ],
      },
    height: {
      type: String,
      default: '300px',
    },
  },
  mounted() {
    this.loadGoogleCharts();
  },
  methods: {
    loadGoogleCharts() {
      const apiKey = process.env.VUE_APP_GOOGLE_API_KEY;
      const script = document.createElement('script');
      script.src = `https://www.gstatic.com/charts/loader.js?key=${apiKey}`;
      script.onload = () => {
        window.google.charts.load('current', { packages: ['corechart'] });
        window.google.charts.setOnLoadCallback(this.drawChart);
      };
      document.head.appendChild(script);
    },
    drawChart() {
        const keys = this.keys;
        const data = this.data.map((item) => {
            return [item.name, item.value<0? 0: item.value ];
        }) || []
      const chartData = window.google.visualization.arrayToDataTable([
        keys,
        ...data,
      ])

      const options = {
        title: '',
        is3D: true,
        legend: { position: 'right' },
        colors: ["#4CAF50", "#2196F3", "#FF9800", "#9C27B0"],
        chartArea: { width: "90%", height: "100%" },
        pieSliceText: 'value',
      }

      const chart = new window.google.visualization.PieChart(this.$refs.piechart)
      chart.draw(chartData, options)
    }
  },
  watch: {
    data() {
      this.drawChart();
    },
  },
}
</script>
